import { render } from "./BaseTreeViewArticles.vue?vue&type=template&id=d6938f4c&scoped=true"
import script from "./BaseTreeViewArticles.vue?vue&type=script&lang=js"
export * from "./BaseTreeViewArticles.vue?vue&type=script&lang=js"

import "./BaseTreeViewArticles.vue?vue&type=style&index=0&id=d6938f4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6938f4c"]])

export default __exports__